import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import configureStore from "./config/configureStore";
import configureRenders from "./config/configureRenders";
import configureSessionWatcher from "./config/configureSessionWatcher";

import reportWebVitals from "./reportWebVitals";
import Root from "./Root";

const store = configureStore({});
configureSessionWatcher(store.dispatch);
configureRenders(store);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Root />
    </BrowserRouter>
  </Provider>
);

reportWebVitals();
